<template>
  <div class="login-form">
    <b-alert variant="danger" :show="hasSubmitError" dismissible>
      {{$t('login.submitError')}}
    </b-alert>

    <b-form novalidate @submit.stop.prevent="login">
      <b-form-group
        id="email-input-group"
        :label="$t('login.emailLabel')"
        label-for="email-input"
      >
        <b-form-input
          type="email"
          id="email-input"
          name="email"
          v-model="email"
          v-validate="{required: true, email: true}"
          :state="validateState('email')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('login.emailInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="password-input-group"
        :label="$t('login.passwordLabel')"
        label-for="password-input"
      >
        <b-form-input
          type="password"
          id="password-input"
          name="password"
          v-model="password"
          v-validate="{required: true, min: 6}"
          :state="validateState('password')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('login.passwordInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-row>
        <b-col>
          <loading-button
            :text="$t('login.btnText')"
            :loading-text="$t('login.btnLoadingText')"
            variant="primary"
            :loading=submitting
            type="submit"
            :disabled="veeErrors.any()"
          />
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <p>
            {{$t('login.forgottenPassword')}}
            <router-link to="/forgotten-password">{{$t('login.requestReset')}}</router-link>
            .
          </p>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col>
          <p>
            {{$t('login.needAccount')}}
            <router-link to="/register">{{$t('login.clickHere')}}</router-link>
            {{$t('login.getStarted')}}
          </p>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import FormValidation from '../../mixins/FormValidation';

  export default {
    mixins: [FormValidation],
    computed: mapState({
      user: state => state.account.user,
    }),
    data() {
      return {
        submitting: false,
        email: '',
        password: '',
        hasSubmitError: false,
      };
    },
    methods: {
      login() {
        this.$validator.validateAll().then((result) => {
          if (!result) {
            return;
          }
          this.submitting = true;
          this.$store.dispatch('account/login', { email: this.email, password: this.password })
            .then(() => {
              this.hasSubmitError = false;
              this.$toasted.success(this.$t('login.loginWelcomeMessage', { name: this.user.firstName }), {
                icon: 'star',
              });
              this.$router.push('/');
            })
            .catch(() => {
              this.hasSubmitError = true;
            })
            .finally(() => {
              this.submitting = false;
            });
        });
      },
    },
  };
</script>
